import { AlertCircle, RotateCw } from 'lucide-react';

interface Props {
  text: string;
  onRetry: () => void;
}

export default function ErrorMessage({ text, onRetry }: Props) {
  return (
    <div
      className="bg-red-50 border border-red-200 rounded-2xl rounded-tl-sm p-4 max-w-3xl"
      role="alert"
    >
      <div className="flex items-start gap-2">
        <AlertCircle className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-red-800">{text}</p>
          <button
            type="button"
            onClick={onRetry}
            className="mt-2 inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-red-600 text-white text-xs font-medium hover:bg-red-700"
          >
            <RotateCw className="w-3 h-3" /> Retry
          </button>
        </div>
      </div>
    </div>
  );
}
